import { gql } from "@apollo/client"

export const AUTHORIZED_DEALERS = gql`
  query DealersQuery($limit: Int, $nextToken: String) {
    listDealers(limit: $limit, nextToken: $nextToken) {
      count
      nextToken
      items {
        id
        address
        city
        name
        phone
        state
        country
        website
        coordinates {
          latitude
          longitude
        }
      }
    }
  }
`

export const LIST_EVENTS = gql`
  query listEvents($filter: listEventsFilterInput) {
    listEvents(filter: $filter) {
      items {
        eventName
        description
        eventType
        sponsorshipTitle
        id
        image
        eventLocation
        date
        country
        city
        coordinates {
          latitude
          longitude
        }
        startDate
        endDate
        state
        userId
        visibility
        durationMinutes
        bufferMinutes
        capacity
        timezone
        dailyStartTime
        dailyEndTime
        fullPaymentAtBooking
      }
    }
  }
`

export const GET_AVAILABILITY = gql`
  query getAvailability($eventId: ID!, $date: AWSDate!) {
    getAvailability(eventId: $eventId, date: $date) {
      startTime
      endTime
      remaining
    }
  }
`